// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CustomLeaf_wrap__ciyYQ"};